
export default {
    name: 'AuthLayout',
};
